import type {DataGranularity} from '../../api/types';

export type Scale =
  | 'day'
  | 'week'
  | 'month'
  | 'year'
  | 'last24Hours'
  | 'last7Days'
  | 'last30Days';

const HOURLY_SCALES: Scale[] = ['day', 'last24Hours', 'week', 'last7Days'];

/**
 * Picks the natural chart granularity for a given period scale: hourly for
 * sub-day windows (day, last24Hours, week, last7Days) and daily for the rest.
 */
export const granularityForScale = (scale: Scale): DataGranularity =>
  HOURLY_SCALES.includes(scale) ? 'H' : 'D';
